import React from 'react';

import InfoIcon from '@mui/icons-material/Info';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Button, IconButton, Stack, Tooltip } from '@mui/material';

import UnsavedChangesInfoIcon from '~/components/Common/Elements/UnsavedChangesInfoIcon';

type VoucherFormNavigationProps = {
  isSubmitting: boolean;
  hasUnsavedChanges: boolean;
  isEdit: boolean;
  showAdvanceDescription: boolean;
  onBack: () => void;
  onToggleAdvancedDescription: () => void;
  onOpenClone?: () => void;
  showExtendedWarnings: boolean;
  onToggleExtendedWarnings?: () => void;
};

export default function VoucherFormNavigation({
  isSubmitting,
  hasUnsavedChanges,
  isEdit,
  showAdvanceDescription,
  onBack,
  onToggleAdvancedDescription,
  onOpenClone,
  showExtendedWarnings,
  onToggleExtendedWarnings,
}: VoucherFormNavigationProps) {
  return (
    <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" alignItems="center">
      <Button variant="text" onClick={onBack} disabled={isSubmitting}>
        Back to list
      </Button>
      <UnsavedChangesInfoIcon hasUnsavedChanges={hasUnsavedChanges} />
      {isEdit && onOpenClone && (
        <Button variant="text" onClick={onOpenClone} disabled={isSubmitting}>
          Clone
        </Button>
      )}
      {isEdit && onToggleExtendedWarnings && (
        <Tooltip title={showExtendedWarnings ? 'Hide extended warnings' : 'Show extended warnings'}>
          <IconButton
            aria-label={showExtendedWarnings ? 'Hide extended warnings' : 'Show extended warnings'}
            aria-pressed={showExtendedWarnings}
            color={showExtendedWarnings ? 'primary' : 'default'}
            onClick={onToggleExtendedWarnings}
            disabled={isSubmitting}
            size="small"
          >
            <WarningAmberIcon />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title={showAdvanceDescription ? 'Hide advanced field guidance' : 'Show advanced field guidance'}>
        <IconButton
          aria-label={showAdvanceDescription ? 'Hide advanced field guidance' : 'Show advanced field guidance'}
          aria-pressed={showAdvanceDescription}
          onClick={onToggleAdvancedDescription}
          disabled={isSubmitting}
          size="small"
        >
          <InfoIcon />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
